import React from 'react';
import moment from 'moment';
import { toArray } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    EBON_ACTIVATION_TYPE_ONLINE,
    EBON_ACTIVATION_TYPE_OFFLINE,
    EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE
} from '../../../constants/ebon';
import { HIDE_ALO } from '../../../constants';
import { PATH } from '../../../constants/path';
import { MOMENTJS_DATE_FORMAT } from '../../../constants/moment';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';

import { showModal } from '../../../services/modal/actions';

import { getPartner, getEbonPartner } from '../../../services/partner/selector';

import {
    getInstertitielCashbackUrl,
    displayableCashback,
    hasCashback,
    hasCashbackOffline,
    hasEbon
} from '../../../services/partner/utils';

import LinkButtonComponent from '../../button/LinkButtonComponent';
import PartnerBlockHorizontalComponent from '../../partner/PartnerBlockHorizontalComponent';

const DELAI_VALIDATION_DEFAULT = 15;

class HeaderComponent extends React.Component {
    showLoginModal = redirection => event => {
        const { isAuthenticated, showModal } = this.props;
        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGIN);
            return false;
        }
    };

    getAvailability = e => {
        const { i18nPage } = this.props;

        if (e.activationType === EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE) {
            return i18nPage.EBON_TYPE_ON_OFF;
        } else if (e.activationType === EBON_ACTIVATION_TYPE_ONLINE) {
            return i18nPage.EBON_TYPE_ON;
        } else if (e.activationType === EBON_ACTIVATION_TYPE_OFFLINE) {
            return i18nPage.EBON_TYPE_OFF;
        }
        return null;
    };

    renderCashback = () => {
        const { i18nPartner, partner, isOffline, discounts, isEbon, ebonPartner } = this.props;
        if (
            (partner &&
                ((!isOffline && hasCashback(partner)) ||
                    (isOffline && hasCashbackOffline(partner)))) ||
            (isEbon && hasEbon(ebonPartner))
        ) {
            const { percent, fixed, initialPercent, initialFixed, label } = isOffline
                ? partner.mostDisplayableDiscountOffline
                : isEbon && ebonPartner && ebonPartner.ebonDiscount
                ? {
                      fixed: ebonPartner.ebonDiscount.cashback.fixed.value,
                      percent: ebonPartner.ebonDiscount.cashback.percent.value,
                      initialPercent: ebonPartner.ebonDiscount.cashback.percent.initialValue
                  }
                : partner.mostDisplayableDiscountOnline;
            const initialCashback = displayableCashback(initialPercent, initialFixed);
            const isMultiDiscount =
                discounts &&
                !isEbon &&
                discounts.filter(d => (isOffline ? d.offlineActive : d.onlineActive)).length > 1;

            return (
                <div className="cashback">
                    <span className="upTo">{isMultiDiscount && `${i18nPartner.jusqua} `}</span>
                    <span>
                        <span className="value">
                            {displayableCashback(percent, fixed)} {i18nPartner.rembourse}
                            {(percent > 1 || fixed > 1) && 's'}
                        </span>
                    </span>{' '}
                    {label || (
                        <span>
                            {isEbon
                                ? i18nPartner.EBON_DISCOUNT_LABEL
                                : i18nPartner.DEFAULT_DISCOUNT_LABEL}
                            &nbsp;
                            {initialCashback && (
                                <span className="olieu grey">
                                    &nbsp;
                                    {i18nPartner.aulieude} {initialCashback}
                                </span>
                            )}
                        </span>
                    )}
                </div>
            );
        } else {
            return <div className="cashback">{i18nPartner.pasdecashbackencemoment}</div>;
        }
    };

    // render the estimated date validation block
    renderEstimatedValidationDate = () => {
        const { partner, i18nPage, isEbon } = this.props;

        if (isEbon) return null;

        const validationDelay = partner ? partner.validationDelay : DELAI_VALIDATION_DEFAULT;
        const isValidationAfterServiceConsumption =
            partner && partner.validationAfterServiceConsumption;
        const estimatedValidationDate = moment()
            .add(validationDelay, 'days')
            .format(MOMENTJS_DATE_FORMAT);

        return partner && partner.validationDelay > -1 && hasCashback(partner) ? (
            <div className="validation-date">
                {`${i18nPage.ESTIMATED_VALIDATION_DATE} `}
                <br className="show-mobonly" />
                <span>
                    {isValidationAfterServiceConsumption
                        ? i18nPage.VALIDATION_AFTER_SERVICE_CONSUMPTION
                        : estimatedValidationDate}
                </span>
            </div>
        ) : null;
    };

    renderCTAButton = () => {
        const { isOffline, isEbon, partner, i18nPage } = this.props;
        const url = getInstertitielCashbackUrl(partner);

        if (!isEbon && !isOffline && partner) {
            return (
                <LinkButtonComponent
                    color="main"
                    text={i18nPage.TAKETHEOFFER}
                    title={i18nPage.TAKETHEOFFER}
                    to={url}
                    target="_blank"
                    onClick={this.showLoginModal(url)}
                />
            );
        }
        if (isOffline && partner) {
            return (
                <React.Fragment>
                    <LinkButtonComponent
                        to={`${PATH.FLASHING_TICKET_PATH}?id=${partner.id}`}
                        color="main"
                        text={i18nPage.SEND_TICKET}
                        title={i18nPage.SEND_TICKET}
                        onClick={this.showLoginModal(url)}
                    />
                    {!HIDE_ALO && (
                        <LinkButtonComponent
                            to={PATH.ALO_PATH}
                            color="sixth"
                            text={i18nPage.SYNCHRO_BANK_ACCOUNT}
                            title={i18nPage.SYNCHRO_BANK_ACCOUNT}
                            onClick={this.showLoginModal(url)}
                        />
                    )}
                </React.Fragment>
            );
        }

        return null;
    };

    render() {
        const { partner, isEbon, ebonPartner } = this.props;
        const currentPartner = isEbon ? ebonPartner : partner;

        return (
            <PartnerBlockHorizontalComponent
                partner={currentPartner}
                noLogoLink
                cssClass="fm-entete">
                <div className="fm-entete-offre-bt grid has-gutter flex-center-alt">
                    <div className="fm-entete-offre">
                        {this.renderCashback()}
                        {this.renderEstimatedValidationDate()}
                        {isEbon && ebonPartner && ebonPartner.ebonDiscount && (
                            <p className="availabilityType">
                                {this.getAvailability(ebonPartner.ebonDiscount)}
                            </p>
                        )}
                    </div>
                    {!isEbon && (
                        <div className="fm-entete-bt flex-container-v">
                            {this.renderCTAButton()}
                        </div>
                    )}
                </div>
            </PartnerBlockHorizontalComponent>
        );
    }
}

HeaderComponent.propTypes = {
    id: PropTypes.string.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    const partner = getPartner(state, ownProps.id);
    const ebonPartner = getEbonPartner(state, Number(ownProps.id));
    const isEbon = ownProps.isEbon;

    return {
        partner,
        ebonPartner,
        i18nPartner: state.i18n.feature.partenaire,
        i18nPage: state.i18n.page.MERCHANTCARD,
        isAuthenticated: state.authentication.isAuthenticated,
        discounts: !isEbon ? toArray(state.discount.discounts[partner.id]) : null
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/HeaderComponent.js